/**
 * Utility to get a translation by key or get all translations.
 * data is a map with 'key's similar to those defined in the translation value,
 * and 'value's replacing those placeholders.
 */

import { useContext } from 'react';
import TranslationsContext from '../store/translations-context';
import { interpolateString } from './shape-utils';

const useTranslation = (userDefinedContext) => {
  const translations = useContext(userDefinedContext || TranslationsContext) || {};

  const getTranslation = (key, data = null) => {
    if (data) {
      return interpolateString(translations[key] || key, data);
    }
    return translations[key] || key;
  };

  return [getTranslation, translations];
};

export default useTranslation;
